import { registerDomain } from '@/config/domainRegistry'

registerDomain(require('@/global/auth').domainConfig())
registerDomain(require('@/global/toast').domainConfig())
registerDomain(require('@/domain/showcases').domainConfig())
